import React from 'react';

interface OperationalDetailsEditableProps {
  yearsInBusiness: number;
  onYearsInBusinessChange: (years: number) => void;
}

const OperationalDetailsEditable: React.FC<OperationalDetailsEditableProps> = ({
  yearsInBusiness,
  onYearsInBusinessChange,
}) => {
  return (
    <section className="mb-8 border-b pb-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Experience</h2>
      <div className="max-w-xs">
        <label htmlFor="years-in-business" className="block text-sm font-medium text-gray-700">Years in Business</label>
        <input
          type="number"
          id="years-in-business"
          min={0}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
          value={yearsInBusiness}
          onChange={(e) => onYearsInBusinessChange(parseInt(e.target.value) || 0)}
        />
      </div>
    </section>
  );
};

export default OperationalDetailsEditable;
